import { SupportContact } from "../../api/supportTypes.ts";
import * as Styles from "./ContactCards.styles.ts";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

interface ContactCardsProps {
	contacts: SupportContact[];
}

const ContactCards = ({ contacts }: ContactCardsProps) => {
	return (
		<Styles.ContactGrid aria-label="Support contacts">
			{contacts.map((contact, index) => {
				const contactName = contact.name ?? "--";
				const isDesignRequestAction = contact.action?.code === "SUBMIT_DESIGN_REQUEST";

				return (
					<Styles.ContactCard key={contact.type ?? contact.email ?? `${contactName}-${index}`}>
						<Styles.ContactCardBody>
							<Styles.ContactHeader>
								<AccountCircleIcon />
								<div>
									<Styles.ContactName>{contactName}</Styles.ContactName>

									{contact.title && <Styles.ContactTitle>{contact.title}</Styles.ContactTitle>}
								</div>
							</Styles.ContactHeader>

							{contact.email && (
								<Styles.ContactRow>
									<EmailIcon />

									<Styles.ContactLink href={`mailto:${contact.email}`}>
										{contact.email}
									</Styles.ContactLink>
								</Styles.ContactRow>
							)}

							{contact.phone && (
								<Styles.ContactRow>
									<PhoneIcon />
									<Styles.ContactText>{contact.phone}</Styles.ContactText>
								</Styles.ContactRow>
							)}

							{!!contact.hours?.length && (
								<Styles.ContactRow>
									<AccessTimeOutlinedIcon />

									<Styles.Hours>
										{contact.hours.map((hours) => (
											<Styles.Hour key={`${contact.type}-${hours}`}>{hours}</Styles.Hour>
										))}
									</Styles.Hours>
								</Styles.ContactRow>
							)}

							{isDesignRequestAction && contact.action?.label && (
								<Styles.ContactAction
									disabled
									type="button"
								>
									{contact.action.label}
								</Styles.ContactAction>
							)}
						</Styles.ContactCardBody>
					</Styles.ContactCard>
				);
			})}
		</Styles.ContactGrid>
	);
};

export default ContactCards;
